import { app } from 'store';
import store from 'store/store';
import { DisplaySettings } from 'types';
import { queueDisplaySetting, savedDisplaySettingsCopy } from './displaySettingsSave';
import { saveDisplaySettingsRequest } from './displaySettingsRequest';

/** Cog controls call this after updating the live viewer flag. One field per call. */
export function persistDisplaySetting(
  field: keyof DisplaySettings,
  value: DisplaySettings[keyof DisplaySettings],
): void {
  const effect = queueDisplaySetting(field, value);
  store.dispatch(app.actions.setSavedDisplaySettings(savedDisplaySettingsCopy()));
  if (effect.type === 'patch') {
    store.dispatch(saveDisplaySettingsRequest(effect.fields, effect.generation));
  }
}
